import { Vector3 } from 'three';
import { ActionControllerEventName, Tween, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { deepClone } from '@verybigthings/vbt-webvr-framework/build/main/ts/utils/DeepClone';
import { PickingControllerEvents } from '@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController';
import { PreparationPickingObjects } from "../../utils/PreparationPickingObjects";
export default class CapModule extends ViewerModule {
    constructor(model, table, flask, uiContainer, level) {
        super();
        this.level = level;
        // public __inited: boolean = false;
        this.selected = false;
        this.uiObject.name = 'CapModule';
        this.model = model;
        this.model.add(this.innerBigModel = deepClone(this.model));
        this.innerBigModel.position.set(0, 0, 0);
        this.innerBigModel.rotateZ(Math.PI);
        this.innerBigModel.scale.set(2.7, 2.7, 2.7);
        this.innerBigModel.remove(this.innerBigModel.children[0]);
        this.innerBigModel.material.forEach(material => {
            material.visible = false;
        });
        this.table = table;
        this.flask = flask;
        this.defaultPosition = model.position.clone();
        // this.addObject(this.uiContainer = uiContainer);
        this.uiContainer = uiContainer;
    }
    initWaitSelect() {
        this.actionController.once(ActionControllerEventName.click, this.innerBigModel, () => {
            if (Viewer.controls.zController)
                return;
            Viewer.pointerController.setObject(this.model);
            this.visibilityShadow(false);
            this.model.geometry.rotateZ(Math.PI);
            this.selected = true;
            this.fire('selected');
        });
        if (this.level.lobby.app.zSpacePickingController) {
            PreparationPickingObjects.saveObjectState(this.model);
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.PICKED, this.model, () => {
                if (!this.level.interaction)
                    return;
                Viewer.scene.add(this.model);
                this.visibilityShadow(false);
                this.model.geometry.rotateZ(Math.PI);
                this.selected = true;
                this.fire('selected');
            });
        }
    }
    visibilityShadow(visibility = true) {
        const pPlane = this.model.getObjectByName('pPlane');
        if (pPlane)
            pPlane.visible = visibility;
    }
    closeFlask(onComplete) {
        this.flask.add(this.model);
        this.model.position.set(0, 1.2, 0);
        this.flyTo(new Vector3(0, 1.04, 0), 400, onComplete);
    }
    setDefaultPositionRotation() {
        Viewer.pointerController.setObject(null);
        this.visibilityShadow(true);
        this.table.add(this.model);
        this.model.position.copy(this.defaultPosition);
        this.model.rotation.set(0, 0, 0);
    }
    putInFlask() {
        this.model.position.set(-0.3, 5.5, 1.5);
        this.flyTo(new Vector3(-0.3, 5.1, 1.5));
    }
    initWaitApply() {
        this.actionController.once(ActionControllerEventName.click, this.innerBigModel, () => {
            this.fire('applied');
        });
    }
    flyTo(pos, time = 1000, onComplete) {
        new Tween(this.model.position)
            .to(pos.clone(), time)
            .easing(TWEEN.Easing.Linear.None)
            .onComplete(() => onComplete && onComplete())
            .start();
    }
    show(isVisible = true) {
        this.uiObject.visible = isVisible;
    }
}
